export default __webpack_public_path__ + "static/media/Background_00133.5f67e848.png";